<template>
  <el-dialog title="编辑" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="150px">
      <el-form-item label="app应用商店：" prop="appStore" class="width100">
        <el-input v-model="form.appStore"  disabled></el-input>
      </el-form-item>
      <el-form-item label="APP系统：" prop="appSystem" class="width100">
        <el-input v-model="form.appSystem"  disabled></el-input>
      </el-form-item>
      <el-form-item label="功能：" prop="funData" class="width100">
        <el-input v-model="form.funData"  disabled></el-input>
      </el-form-item>
      <el-form-item label="版本号：" prop="appVersionCode" class="width100">
        <el-input v-model="form.appVersionCode" placeholder="请输入版本号"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import onlineEnvironmentSwitchApi from '@/api/system/onlineEnvironmentSwitch'
function initFormBean() {
  const formBean = {
    appVersionCode: ''
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        appVersionCode: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
      },
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 提交表单
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = { ...this.form };
          if (this.form.id > 0) {
            onlineEnvironmentSwitchApi.update(params).then((data) => {
              this.postCallback(data)
            });
          } else {
            onlineEnvironmentSwitchApi.create(params).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    /**
     * 回调
     */
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    // 文件上传成功
    handleSuccess(response, file) {
      this.form.versionUrl = response.data;
      this.form.versionSize = (file.size / (1024 * 1000)).toFixed(2);
    },
    // 文件删除成功
    handleRemove(file) {
      this.form.versionUrl = '';
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.reward-type {
  display: flex;
  & > .el-select {
    &:first-child {
      width: 180px;
      margin-right: 10px;
    }
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-upload-list {
  display: none;
}
</style>